// Vanilla CSS for InfoWithText. Prefix: nfo-. Aggregated into libraryStyles.
// A glass "callout": a tinted glyph chip + copy on one shared vertical axis,
// with tonal variants driven by the --accent-* tokens.
export const infoStyles = `
  .nfo-row {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--space-3);
    padding: var(--space-3) var(--space-4);
    border-radius: var(--radius-md);
    border: 1px solid var(--glass-flat-border);
    /* Rendered once per list row (these callouts stack) — the near-opaque flat
       fill keeps the frosted look without N stacked backdrop-filters. */
    background: var(--glass-flat-solid);
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
    color: var(--text-secondary);
    font-family: var(--font-sans);
    font-size: var(--fs-md);
    line-height: 1.5;
  }
  /* Stacked callouts breathe without the component owning an outer margin. */
  .nfo-row + .nfo-row { margin-top: var(--space-2); }

  .nfo-icon {
    flex: 0 0 auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--space-6);
    height: var(--space-6);
    border-radius: var(--radius-full);
    background: var(--brand-100);
    color: var(--brand-700);
  }
  .nfo-body { flex: 1 1 0%; min-width: 0; }
  .nfo-title {
    margin: 0 0 2px;
    font-weight: 700;
    color: var(--text-primary);
  }
  .nfo-text { margin: 0; font-weight: 500; }

  .nfo-stacked { align-items: flex-start; }
  .nfo-stacked .nfo-icon { margin-top: 1px; }

  .nfo-warning { background: var(--accent-gold-bg); border-color: var(--accent-gold-border); color: var(--accent-gold-text); }
  .nfo-warning .nfo-icon { background: var(--accent-gold-border); color: var(--accent-gold-text); }
  .nfo-success { background: var(--accent-lime-bg); border-color: var(--accent-lime-border); color: var(--accent-lime-text); }
  .nfo-success .nfo-icon { background: var(--accent-lime-border); color: var(--accent-lime-text); }
  .nfo-danger  { background: var(--accent-coral-bg); border-color: var(--accent-coral-border); color: var(--accent-coral-text); }
  .nfo-danger .nfo-icon { background: var(--accent-coral-border); color: var(--accent-coral-text); }
`;
